import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import i18n from '@/libs/i18n'
import { ref } from '@vue/composition-api'
// import useEventsUpload from "@/views/organization/confirmation-planning/events-upload/useEventsUpload";
import { useLambda } from '@/views/habit/awsLambda'
import { useCognito } from '@/views/habit/awsCognito'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useWorkerAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  // const { bulkEventsUpload } = useEventsUpload();
  const userData = store.state?.userStore?.userData
  const isSubmitting = ref(false)
  const { createItem, createCognitoUser } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const collection = 'worker'

  async function create(data) {
    if (!hasPermission('organization-workers', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      // Create worker in MongoDB
      const payload = {
        client_id: oid(userData.client.$oid),
        isComplaintManager: data.isComplaintManager?.value || false,
        history: [createInitialAuditEntry()],
      }

      if (data.name?.value) payload.name = data.name.value
      if (data.email?.value) payload.email = data.email.value
      if (data.realEmail?.value) payload.realEmail = data.realEmail.value
      if (data.supervisors?.value) payload.supervisors = data.supervisors.value.map(e => oid(e))
      if (data.locations?.value) payload.locations = data.locations.value.map(e => oid(e))
      if (data.roles?.value) payload.roles = data.roles.value.map(e => oid(e))
      if (data.privileges?.value) payload.privileges = data.privileges?.value
      if (data.company?.value) payload.company = data.company.value.map(e => oid(e))

      await createItem({ collection, payload })

      // Create user in AWS Cognito
      if (data.email?.value) {
        try {
          const cognitoResult = await createCognitoUser({ email: data.email.value, name: data.name.value })

          if (cognitoResult.error) {
            throw new Error(`Cognito user creation failed: ${cognitoResult}`)
          }
          console.log("user created")
        } catch (error) {
          console.log(`Error creating user ${data.email.value}`)
          console.error(error)
          showErrorMessage(i18n.t('message.cognito_user_error'))
        }
      }

      showSuccessMessage(i18n.t('message.worker_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.worker_error'))
    } finally {
      router.push({ name: 'organization-worker-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    isSubmitting,
  }
}
